module.exports = __webpack_public_path__ + "img/13-mini.9ad10ee2.jpg";